
const storeItems =  [
  {
    id: "001-beetroot",
    name: "beetroot",
    price: 0.55,
    type: 'veg',
    stockQuantity: 2
  },
  {
    id: "002-carrot",
    name: "carrot",
    price: 0.15,
    type: 'veg',
    stockQuantity: 10
  },
  {
    id: "003-apple",
    name: "apple",
    price: 0.25,
    type: 'fruit',
    stockQuantity: 10
  },
  {
    id: "004-apricot",
    name: "apricot",
    price: 0.65,
    type: 'fruit',
    stockQuantity: 5
  },
  {
    id: "005-avocado",
    name: "avocado",
    price: 0.95,
    type: 'veg',
    stockQuantity: 5
  },
  {
    id: "006-bananas",
    name: "bananas",
    price: 0.10,
    type: 'fruit',
    stockQuantity: 10
  },
  {
    id: "007-bell-pepper",
    name: "bell pepper",
    price: 0.45,
    type: 'veg',
    stockQuantity: 10
  },
  {
    id: "008-berry",
    name: "berry",
    price: 0.05,
    type: 'fruit',
    stockQuantity: 50
  },
  {
    id: "009-blueberry",
    name: "blueberry",
    price: 0.05,
    type: 'fruit',
    stockQuantity: 50
  },
  {
    id: "010-eggplant",
    name: "eggplant",
    price: 0.35,
    type: 'veg',
    stockQuantity: 5
  }
]

export default storeItems